window.initializeAlphaSidebar = function () {
    var sidebar = document.querySelector('[data-alpha-sidebar]');
    if (!sidebar || sidebar.hasAttribute('data-alpha-initialized')) return;
    sidebar.setAttribute('data-alpha-initialized', '');
    window.showAlphaSidebar = function () {
      document.querySelectorAll('[data-alpha-sidebar]').forEach(function (el) {
        el.style.transition = 'opacity .18s ease-out';
        el.style.visibility = 'visible';
        requestAnimationFrame(function () {
          el.style.opacity = '1';
        });
      });
    };

    // Mehr anzeigen (nur bei Nicht-Dimensionen)
    document.querySelectorAll('.alpha-facet[data-facet]:not([data-dimension="1"])').forEach(function (facet) {
      var btn = facet.querySelector('[data-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var expanded = facet.hasAttribute('data-expanded');
        var list = facet.querySelector('[data-values]');
        var limit = list ? parseInt(list.getAttribute('data-limit') || '8', 10) : 8;
        facet.querySelectorAll('.alpha-facet__value').forEach(function (li, i) {
          if (expanded && i >= limit) {
            li.classList.add('is-hidden');
          } else {
            li.classList.remove('is-hidden');
          }
        });
        facet.toggleAttribute('data-expanded');
        btn.textContent = facet.hasAttribute('data-expanded') ? 'Weniger anzeigen' : 'Mehr anzeigen';
      });
    });

    // Helpers
    function parseNum(text) {
      if (!text) return NaN;
      var t = ('' + text).replace(',', '.');
      var m = t.match(/[-+]?\d*\.?\d+/);
      return m ? parseFloat(m[0]) : NaN;
    }
    function clamp(v, lo, hi) {
      return Math.max(lo, Math.min(hi, v));
    }

    // Dimensionen: dezimalfähig, gleiche Min/Max-Werte erlaubt, smooth, nur Drag zählt (Klicks verwerfen), Fokus nach Loslassen entfernen,
    // vorherige Auswahl bleibt sichtbar bis "Suche" gedrückt wird; Checkbox-Liste bleibt versteckt
    document.querySelectorAll('.alpha-facet[data-dimension="1"]').forEach(function (facet) {
      var ui = facet.querySelector('[data-dimension-ui]');
      if (!ui) return;

      // Werte-/Checkboxliste semantisch verstecken (bleibt im DOM für das Setzen der Filter)
      var valuesList = facet.querySelector('[data-values]');
      if (valuesList) {
        valuesList.hidden = true;
        valuesList.setAttribute('aria-hidden', 'true');
      }

      var rmin = ui.querySelector('[data-rmin]');
      var rmax = ui.querySelector('[data-rmax]');
      var nmin = ui.querySelector('[data-min]');
      var nmax = ui.querySelector('[data-max]');
      var bar = ui.querySelector('[data-rangebar]');
      var applyBtn = ui.querySelector('[data-apply]');
      var form = facet.closest('form');

      function parseNum(text) {
        if (!text) return NaN;
        var t = String(text).replace(',', '.');
        var m = t.match(/[-+]?\d*\.?\d+/);
        return m ? parseFloat(m[0]) : NaN;
      }
      function clamp(v, lo, hi) {
        return Math.max(lo, Math.min(hi, v));
      }
      function toRangeValue(v) {
        return String(Number(v));
      }
      function formatDisplayNumber(v) {
        return String(Number(v)).replace('.', ',');
      }
      function decimalPlaces(v) {
        var s = String(v);
        if (s.indexOf('e-') > -1) return parseInt(s.split('e-')[1], 10) || 0;
        var dot = s.indexOf('.');
        return dot === -1 ? 0 : s.length - dot - 1;
      }
      function getRangeStep(values) {
        var places = 0;
        values.forEach(function (v) {
          places = Math.max(places, decimalPlaces(v));
        });
        return places > 0 ? String(Math.pow(10, -Math.min(places, 3))) : '1';
      }

      // Werte aus (versteckter) Liste lesen
      var items = [];
      facet.querySelectorAll('.alpha-facet__value').forEach(function (li) {
        var tx = li.querySelector('.alpha-checkbox__text');
        if (!tx) return;
        var raw = tx.childNodes[0] ? tx.childNodes[0].textContent : tx.textContent;
        var val = parseNum(raw);
        var cb = li.querySelector('.alpha-checkbox__input');
        // Strictly filter out invalid, zero, or negative numbers
        if (!isNaN(val) && isFinite(val) && val > 0.0001 && cb) {
          items.push({ n: val, cb: cb });
        }
      });
      if (items.length === 0) return;
      items.sort(function (a, b) {
        return a.n - b.n;
      });

      // Bereich: first item .. Daten-Max
      var uiMin = items.length > 0 ? items[0].n : 0;
      var dataMax = items[items.length - 1].n;
      var rangeStep = getRangeStep(
        items.map(function (it) {
          return it.n;
        })
      );

      // Mindestabstand 0: Bereiche wie 518 - 518 müssen gültig bleiben.
      var minGap = 0;

      [rmin, rmax].forEach(function (el) {
        if (!el) return;
        el.min = toRangeValue(uiMin);
        el.max = toRangeValue(dataMax);
        el.step = rangeStep;
      });
      if (nmin) {
        nmin.placeholder = formatDisplayNumber(uiMin);
      }
      if (nmax) {
        nmax.placeholder = formatDisplayNumber(dataMax);
      }

      // === "Commit"-Zustand: was aktuell wirklich ausgewählt ist (sichtbar, wenn man NICHT hält) ===
      // Aus aktiven Checkboxen ermitteln; sonst voller Bereich
      var activeNums = items
        .filter(function (it) {
          return it.cb.checked;
        })
        .map(function (it) {
          return it.n;
        });
      var committed = {
        lo: activeNums.length ? Math.min.apply(null, activeNums) : uiMin,
        hi: activeNums.length ? Math.max.apply(null, activeNums) : dataMax,
      };
      if (nmin) nmin.value = formatDisplayNumber(committed.lo);
      if (nmax) nmax.value = formatDisplayNumber(committed.hi);

      function setUI(lo, hi) {
        lo = clamp(Number(lo), uiMin, dataMax);
        hi = clamp(Number(hi), uiMin, dataMax);
        if (hi - lo < minGap) {
          hi = clamp(lo + minGap, uiMin + minGap, dataMax);
        }
        rmin.value = toRangeValue(lo);
        rmax.value = toRangeValue(hi);
        // Do NOT set nmin/nmax values here - let inputs stay empty or keep user's typed value
        syncBar();
      }
      function setUIFromCommitted() {
        setUI(committed.lo, committed.hi);
      }

      // Startansicht = committed
      setUIFromCommitted();

      // Smooth Bar-Update (throttled)
      var rafId = null;
      function syncBar() {
        if (!bar) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          var a = (parseFloat(rmin.value) - uiMin) / (dataMax - uiMin || 1);
          var b = (parseFloat(rmax.value) - uiMin) / (dataMax - uiMin || 1);
          bar.style.left = a * 100 + '%';
          bar.style.right = 100 - b * 100 + '%';
        });
      }

      // Gap-Logik aus Range (für Vorschau)
      function enforceFromRange(target) {
        var a = parseFloat(rmin.value || committed.lo);
        var b = parseFloat(rmax.value || committed.hi);

        a = clamp(a, uiMin, dataMax);
        b = clamp(b, uiMin, dataMax);

        if (b - a < minGap) {
          if (target === rmin) {
            a = clamp(b - minGap, uiMin, dataMax - minGap);
          } else {
            b = clamp(a + minGap, uiMin + minGap, dataMax);
          }
        }

        rmin.value = toRangeValue(a);
        rmax.value = toRangeValue(b);
        if (nmin) nmin.value = formatDisplayNumber(a);
        if (nmax) nmax.value = formatDisplayNumber(b);
        syncBar();
      }

      // Gap-Logik aus Number-Feldern (Vorschau – kein Commit)
      function enforceFromNumbers(writeBack) {
        var a = nmin && nmin.value !== '' ? parseNum(nmin.value) : parseFloat(rmin.value);
        var b = nmax && nmax.value !== '' ? parseNum(nmax.value) : parseFloat(rmax.value);

        a = clamp(isNaN(a) ? committed.lo : a, uiMin, dataMax);
        b = clamp(isNaN(b) ? committed.hi : b, uiMin, dataMax);

        if (b - a < minGap) {
          if (a <= uiMin) {
            b = clamp(a + minGap, uiMin + minGap, dataMax);
          } else {
            a = clamp(b - minGap, uiMin, dataMax - minGap);
          }
        }

        rmin.value = toRangeValue(a);
        rmax.value = toRangeValue(b);
        syncBar();

        if (writeBack) {
          if (nmin && nmin.value !== '') {
            nmin.value = formatDisplayNumber(a);
          }
          if (nmax && nmax.value !== '') {
            nmax.value = formatDisplayNumber(b);
          }
        }
      }

      // --- Drag-Guard für Range-Inputs ---
      // Nur "echtes Halten/Bewegen" zählt. Klicks oder minimaler Wackler verwerfen & alte Auswahl anzeigen.
      function addDragGuard(el) {
        if (!el) return;
        var startValue = null;
        var startX = 0;
        var moved = false;
        var movePxThreshold = 4; // min. 4px Bewegung
        var valueThreshold = parseFloat(rangeStep) || 1;

        el.addEventListener('pointerdown', function (ev) {
          startValue = parseFloat(el.value);
          startX = ev.clientX || 0;
          moved = false;
          if (el.setPointerCapture) {
            try {
              el.setPointerCapture(ev.pointerId);
            } catch (e) {}
          }
          ui.setAttribute('data-dragging', '1');
        });

        el.addEventListener('pointermove', function (ev) {
          if (startValue === null) return;
          var dx = Math.abs((ev.clientX || 0) - startX);
          var dv = Math.abs(parseFloat(el.value) - startValue);
          if (dx >= movePxThreshold || dv >= valueThreshold) {
            moved = true;
          }
        });

        function endDrag() {
          // Fokus entfernen, damit der Slider nach Loslassen nicht "ausgewählt" wirkt
          try {
            el.blur();
          } catch (e) {}
          if (document.activeElement === el) {
            try {
              document.activeElement.blur();
            } catch (e) {}
          }

          // Wenn NICHT wirklich gezogen wurde -> komplett auf committed zurückspringen
          if (!moved) {
            setUIFromCommitted();
          } else {
            // Wenn gezogen wurde, Vorschau-Werte bleiben sichtbar (kein Commit!)
            enforceFromRange(el);
          }
          ui.removeAttribute('data-dragging');
          startValue = null;
          moved = false;
        }

        el.addEventListener('pointerup', endDrag);
        el.addEventListener('pointercancel', endDrag);

        // Zusätzliche Absicherung gegen Klick-Änderungen
        el.addEventListener(
          'click',
          function (e) {
            if (startValue !== null && !moved) {
              e.preventDefault();
              e.stopPropagation();
              setUIFromCommitted();
            }
          },
          true
        );
      }

      addDragGuard(rmin);
      addDragGuard(rmax);

      // Listener – flüssig, ohne Nachkommastellen zu runden
      rmin.addEventListener('input', function () {
        enforceFromRange(rmin);
      });
      rmax.addEventListener('input', function () {
        enforceFromRange(rmax);
      });
      rmin.addEventListener('change', function () {
        enforceFromRange(rmin);
      });
      rmax.addEventListener('change', function () {
        enforceFromRange(rmax);
      });

      if (nmin) {
        nmin.addEventListener('change', function () {
          enforceFromNumbers(true);
        });
        nmin.addEventListener('blur', function () {
          enforceFromNumbers(true);
        });
      }
      if (nmax) {
        nmax.addEventListener('change', function () {
          enforceFromNumbers(true);
        });
        nmax.addEventListener('blur', function () {
          enforceFromNumbers(true);
        });
      }

      // "Suche" = Commit + Submit
      function applyAndSubmit() {
        // Validate and clamp user input first (keeps slider + bar in sync)
        enforceFromNumbers(true);

        // Commit: aktuelle (Vorschau-)Werte dauerhaft übernehmen
        committed.lo = parseFloat(rmin.value);
        committed.hi = parseFloat(rmax.value);
        if (nmin) nmin.value = formatDisplayNumber(committed.lo);
        if (nmax) nmax.value = formatDisplayNumber(committed.hi);
        setUIFromCommitted();

        // Checkboxen entsprechend setzen
        items.forEach(function (it) {
          if (!it.cb.disabled) it.cb.checked = false;
        });
        items.forEach(function (it) {
          if (it.cb.disabled) return;
          if (it.n >= committed.lo && it.n <= committed.hi) {
            it.cb.checked = true;
          }
        });

        // Trigger AJAX instead of form submit
        // The AJAX listener below will handle this
        if (window.applySidebarFilterAjax) {
          var formData = new FormData(form);
          var params = new URLSearchParams(formData);
          var url = form.action + '?' + params.toString();
          if (window.buildSidebarUrlWithBatteriefinder) {
            url = window.buildSidebarUrlWithBatteriefinder(url);
          }
          window.applySidebarFilterAjax(url);
        }
      }
      if (applyBtn) {
        applyBtn.addEventListener('click', applyAndSubmit);
      }
    });

    window.showAlphaSidebar();

    // Create a global function to initialize all sidebar event listeners
    // This will be called on page load AND after AJAX updates
    window.initializeSidebarListeners = function () {
      // Mehr anzeigen (nur bei Nicht-Dimensionen)
      document.querySelectorAll('.alpha-facet[data-facet]:not([data-dimension="1"])').forEach(function (facet) {
        var btn = facet.querySelector('[data-toggle]');
        if (!btn) return;

        // Remove old listeners by cloning
        var newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        newBtn.addEventListener('click', function () {
          var expanded = facet.hasAttribute('data-expanded');
          var list = facet.querySelector('[data-values]');
          var limit = list ? parseInt(list.getAttribute('data-limit') || '8', 10) : 8;
          facet.querySelectorAll('.alpha-facet__value').forEach(function (li, i) {
            if (expanded && i >= limit) {
              li.classList.add('is-hidden');
            } else {
              li.classList.remove('is-hidden');
            }
          });
          facet.toggleAttribute('data-expanded');
          newBtn.textContent = facet.hasAttribute('data-expanded') ? 'Weniger anzeigen' : 'Mehr anzeigen';
        });
      });

      // Re-initialize dimension logic
      document.querySelectorAll('.alpha-facet[data-dimension="1"]').forEach(function (facet) {
        var ui = facet.querySelector('[data-dimension-ui]');
        if (!ui) return;

        // Re-initialize dimension controls after AJAX updates.
        var valuesList = facet.querySelector('[data-values]');
        if (valuesList) {
          valuesList.hidden = true;
          valuesList.setAttribute('aria-hidden', 'true');
          try {
            valuesList.style.display = 'none';
          } catch (e) {}
        }

        var form = facet.closest('form');
        var applyBtn = ui.querySelector('[data-apply]');
        var minInput = ui.querySelector('[data-min]');
        var maxInput = ui.querySelector('[data-max]');
        var rmin = ui.querySelector('[data-rmin]');
        var rmax = ui.querySelector('[data-rmax]');
        var rangebar = ui.querySelector('[data-rangebar]');

        if (!minInput || !maxInput || !rmin || !rmax || !rangebar) return;

        var items = [];
        if (valuesList) {
          valuesList.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
            var val = (cb.value || '').trim();
            // Parse number carefully
            var n = parseFloat(val.replace(',', '.').replace(/[^0-9.-]/g, ''));
            // Strictly filter out invalid, zero, or negative numbers
            if (!isNaN(n) && isFinite(n) && n > 0.0001) {
              items.push({ cb: cb, n: n });
            }
          });
        }
        items.sort(function (a, b) {
          return a.n - b.n;
        });

        // Safe defaults avoiding 0 if possible
        var globalMin = items.length > 0 ? items[0].n : 0;
        var globalMax = items.length > 0 ? items[items.length - 1].n : 100;
        var rangeStep = getRangeStep(
          items.map(function (it) {
            return it.n;
          })
        );

        // Extra safety: active filters might define the committed range correctly
        // even if globalMin logic glitches, but for the slider bar UI:
        if (globalMin === 0 && items.length > 0) {
          // Should not happen with above filter, but just in case
          globalMin = items[0].n;
        }

        var minGap = 0;

        rmin.min = toRangeValue(globalMin);
        rmin.max = toRangeValue(globalMax);
        rmin.step = rangeStep;
        rmax.min = toRangeValue(globalMin);
        rmax.max = toRangeValue(globalMax);
        rmax.step = rangeStep;

        var activeNums = items
          .filter(function (it) {
            return it.cb.checked;
          })
          .map(function (it) {
            return it.n;
          });
        var committed = {
          lo: activeNums.length ? Math.min.apply(null, activeNums) : globalMin,
          hi: activeNums.length ? Math.max.apply(null, activeNums) : globalMax,
        };

        if (minInput) {
          minInput.placeholder = formatDisplayNumber(globalMin);
          minInput.value = formatDisplayNumber(committed.lo);
        }
        if (maxInput) {
          maxInput.placeholder = formatDisplayNumber(globalMax);
          maxInput.value = formatDisplayNumber(committed.hi);
        }

        function parseNum(text) {
          if (!text) return NaN;
          var t = ('' + text).replace(',', '.');
          var m = t.match(/[-+]?\d*\.?\d+/);
          return m ? parseFloat(m[0]) : NaN;
        }

        function clamp(v, lo, hi) {
          return Math.max(lo, Math.min(hi, v));
        }
        function toRangeValue(v) {
          return String(Number(v));
        }
        function formatDisplayNumber(v) {
          return String(Number(v)).replace('.', ',');
        }
        function decimalPlaces(v) {
          var s = String(v);
          if (s.indexOf('e-') > -1) return parseInt(s.split('e-')[1], 10) || 0;
          var dot = s.indexOf('.');
          return dot === -1 ? 0 : s.length - dot - 1;
        }
        function getRangeStep(values) {
          var places = 0;
          values.forEach(function (v) {
            places = Math.max(places, decimalPlaces(v));
          });
          return places > 0 ? String(Math.pow(10, -Math.min(places, 3))) : '1';
        }

        function setUIFromCommitted() {
          var lo = Number(committed.lo);
          var hi = Number(committed.hi);
          // Do NOT set minInput/maxInput values - let user type freely
          rmin.value = toRangeValue(lo);
          rmax.value = toRangeValue(hi);

          // Calculate percentage positions for the active range bar
          var totalRange = globalMax - globalMin;
          var pct1 = totalRange > 0 ? ((lo - globalMin) / totalRange) * 100 : 0;
          var pct2 = totalRange > 0 ? ((hi - globalMin) / totalRange) * 100 : 100;

          rangebar.style.left = pct1 + '%';
          rangebar.style.right = 100 - pct2 + '%';
        }

        function enforceFromRange(el) {
          var vmin = parseFloat(rmin.value);
          var vmax = parseFloat(rmax.value);
          if (vmin > vmax - minGap) {
            if (el === rmin) vmin = vmax - minGap;
            else vmax = vmin + minGap;
          }
          vmin = clamp(vmin, globalMin, globalMax);
          vmax = clamp(vmax, globalMin, globalMax);
          // Do NOT set minInput/maxInput values - let user type freely
          rmin.value = toRangeValue(vmin);
          rmax.value = toRangeValue(vmax);

          // Calculate percentage positions for the active range bar
          var totalRange = globalMax - globalMin;
          var pct1 = totalRange > 0 ? ((vmin - globalMin) / totalRange) * 100 : 0;
          var pct2 = totalRange > 0 ? ((vmax - globalMin) / totalRange) * 100 : 100;

          rangebar.style.left = pct1 + '%';
          rangebar.style.right = 100 - pct2 + '%';
          if (minInput) minInput.value = formatDisplayNumber(vmin);
          if (maxInput) maxInput.value = formatDisplayNumber(vmax);
        }

        function enforceFromNumbers(writeBack) {
          var vmin = parseNum(minInput.value);
          var vmax = parseNum(maxInput.value);

          if (isNaN(vmin)) vmin = parseFloat(rmin.value);
          if (isNaN(vmax)) vmax = parseFloat(rmax.value);

          vmin = clamp(vmin, globalMin, globalMax);
          vmax = clamp(vmax, globalMin, globalMax);

          if (vmax - vmin < minGap) {
            if (vmin <= globalMin) {
              vmax = clamp(vmin + minGap, globalMin + minGap, globalMax);
            } else {
              vmin = clamp(vmax - minGap, globalMin, globalMax - minGap);
            }
          }

          rmin.value = toRangeValue(vmin);
          rmax.value = toRangeValue(vmax);
          enforceFromRange(rmax);

          if (writeBack) {
            if (minInput && minInput.value !== '') minInput.value = formatDisplayNumber(vmin);
            if (maxInput && maxInput.value !== '') maxInput.value = formatDisplayNumber(vmax);
          }
        }

        setUIFromCommitted();

        // Removed input listeners to allow free typing
        // minInput.addEventListener('input', function () {
        //   var v = parseNum(minInput.value);
        //   if (isNaN(v)) return;
        //   rmin.value = v;
        //   enforceFromRange(rmin);
        // });

        // maxInput.addEventListener('input', function () {
        //   var v = parseNum(maxInput.value);
        //   if (isNaN(v)) return;
        //   rmax.value = v;
        //   enforceFromRange(rmax);
        // });

        var startValue = null;
        var moved = false;

        function addDragGuard(el) {
          function startDrag() {
            startValue = parseFloat(el.value);
            moved = false;
            ui.setAttribute('data-dragging', '1');
          }

          function moveDrag() {
            if (startValue === null) return;
            var current = parseFloat(el.value);
            if (Math.abs(current - startValue) > 0) moved = true;
          }

          function endDrag() {
            if (startValue !== null) {
              if (moved) enforceFromRange(el);
              ui.removeAttribute('data-dragging');
              startValue = null;
              moved = false;
            }
          }

          el.addEventListener('pointerdown', startDrag);
          el.addEventListener('pointermove', moveDrag);
          el.addEventListener('pointerup', endDrag);
          el.addEventListener('pointercancel', endDrag);

          el.addEventListener(
            'click',
            function (e) {
              if (startValue !== null && !moved) {
                e.preventDefault();
                e.stopPropagation();
                setUIFromCommitted();
              }
            },
            true
          );
        }

        addDragGuard(rmin);
        addDragGuard(rmax);

        rmin.addEventListener('input', function () {
          enforceFromRange(rmin);
        });
        rmax.addEventListener('input', function () {
          enforceFromRange(rmax);
        });

        rmin.addEventListener('change', function () {
          enforceFromRange(rmin);
        });
        rmax.addEventListener('change', function () {
          enforceFromRange(rmax);
        });

        if (minInput) {
          minInput.addEventListener('change', function () {
            enforceFromNumbers(true);
          });
          minInput.addEventListener('blur', function () {
            enforceFromNumbers(true);
          });
        }
        if (maxInput) {
          maxInput.addEventListener('change', function () {
            enforceFromNumbers(true);
          });
          maxInput.addEventListener('blur', function () {
            enforceFromNumbers(true);
          });
        }

        function applyAndSubmit() {
          // Validate and clamp user input first
          enforceFromNumbers(true);

          // Commit: aktuelle Werte dauerhaft übernehmen
          committed.lo = parseFloat(rmin.value);
          committed.hi = parseFloat(rmax.value);
          if (minInput) minInput.value = formatDisplayNumber(committed.lo);
          if (maxInput) maxInput.value = formatDisplayNumber(committed.hi);
          setUIFromCommitted();

          items.forEach(function (it) {
            if (!it.cb.disabled) it.cb.checked = false;
          });
          items.forEach(function (it) {
            if (it.cb.disabled) return;
            if (it.n >= committed.lo && it.n <= committed.hi) {
              it.cb.checked = true;
            }
          });

          // Trigger AJAX instead of form submit
          if (window.applySidebarFilterAjax) {
            var formData = new FormData(form);
            var params = new URLSearchParams(formData);
            var url = form.action + '?' + params.toString();
            if (window.buildSidebarUrlWithBatteriefinder) {
              url = window.buildSidebarUrlWithBatteriefinder(url);
            }
            window.applySidebarFilterAjax(url);
          }
        }

        if (applyBtn) {
          // Remove old listener
          var newApplyBtn = applyBtn.cloneNode(true);
          applyBtn.parentNode.replaceChild(newApplyBtn, applyBtn);
          newApplyBtn.addEventListener('click', applyAndSubmit);
        }
      });
    };

    // Call on initial page load
    window.initializeSidebarListeners();
  };

window.initializeSidebarAjax = function () {
    // AJAX Filtering for Desktop Sidebar
    var sidebar = document.querySelector('[data-alpha-sidebar]');
    if (!sidebar || sidebar.hasAttribute('data-alpha-ajax-initialized')) return;
    sidebar.setAttribute('data-alpha-ajax-initialized', '');

    var form = document.getElementById('alpha-sidebar-form');
    if (!form) return;

    var isLoading = false;

    // Helper to preserve all filter.p.tag (Batteriefinder) parameters.
    window.buildSidebarUrlWithBatteriefinder = function (baseUrl) {
      var url = new URL(baseUrl, window.location.origin);
      if (sidebar.closest('search-page')) return url.toString();
      var currentParams = new URLSearchParams(window.location.search);
      var existingTagParams = new Set();

      url.searchParams.forEach(function (value, key) {
        if (key.indexOf('filter.p.tag') === 0) {
          existingTagParams.add(key + '\u0000' + value);
        }
      });

      currentParams.forEach(function (value, key) {
        if (key.indexOf('filter.p.tag') === 0) {
          var token = key + '\u0000' + value;
          if (!existingTagParams.has(token)) {
            url.searchParams.append(key, value);
            existingTagParams.add(token);
          }
        }
      });

      return url.toString();
    };

    // AJAX Filter Function - EXPOSED GLOBALLY for dimension logic
    window.applySidebarFilterAjax = async function (url) {
      var searchFacet = sidebar.closest('search-page') && sidebar.closest('product-facet');
      if (searchFacet) {
        searchFacet.dispatchEvent(new CustomEvent('facet:criteria-changed', { bubbles: true, detail: { url: url } }));
        return;
      }
      if (isLoading) return;
      isLoading = true;

      var facetMain = document.querySelector('#facet-main');
      if (!facetMain) {
        window.location.href = url;
        return;
      }

      // Show loading states
      facetMain.classList.add('is-loading');
      sidebar.classList.add('is-loading');

      try {
        // Get section ID from facet-main
        var sectionId = facetMain.getAttribute('data-section-id');
        var fetchUrl = new URL(url, window.location.origin);

        if (sectionId) {
          fetchUrl.searchParams.set('section_id', sectionId);
        }

        // Fetch new content
        var response = await fetch(fetchUrl.toString());
        var html = await response.text();

        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Update product grid
        var newFacetMain = tempDiv.querySelector('#facet-main');
        if (newFacetMain) {
          // Smooth fade out
          facetMain.style.opacity = '0';
          await new Promise(function (resolve) {
            setTimeout(resolve, 200);
          });

          // Replace content
          facetMain.innerHTML = newFacetMain.innerHTML;

          // Update URL
          window.history.pushState({}, '', url);

          // Fade in
          facetMain.style.opacity = '1';
          facetMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Update sidebar (for active filters)
        var newSidebar = tempDiv.querySelector('[data-alpha-sidebar]');
        if (newSidebar) {
          sidebar.innerHTML = newSidebar.innerHTML;
          // Re-attach AJAX event listeners
          attachSidebarListeners();
          // Re-initialize ALL sidebar event listeners (Mehr anzeigen, Dimensions, etc.)
          if (window.initializeSidebarListeners) {
            window.initializeSidebarListeners();
          }
          if (window.showAlphaSidebar) {
            window.showAlphaSidebar();
          }
        }
      } catch (error) {
        console.error('Sidebar AJAX error:', error);
        window.location.href = url;
      } finally {
        facetMain.classList.remove('is-loading');
        sidebar.classList.remove('is-loading');
        isLoading = false;
      }
    };

    // Attach event listeners to sidebar elements
    function attachSidebarListeners() {
      var currentForm = document.getElementById('alpha-sidebar-form');
      if (!currentForm) return;

      // Checkbox changes
      currentForm.querySelectorAll('[data-ajax-checkbox]').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          var formData = new FormData(currentForm);
          var params = new URLSearchParams(formData);
          var url = currentForm.action + '?' + params.toString();
          url = window.buildSidebarUrlWithBatteriefinder(url);
          window.applySidebarFilterAjax(url);
        });
      });

      // Sort dropdown
      var sortSelect = currentForm.querySelector('[data-ajax-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var formData = new FormData(currentForm);
          var params = new URLSearchParams(formData);
          var url = currentForm.action + '?' + params.toString();
          url = window.buildSidebarUrlWithBatteriefinder(url);
          window.applySidebarFilterAjax(url);
        });
      }

      // Price range button
      currentForm.querySelectorAll('[data-ajax-price]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var formData = new FormData(currentForm);
          var params = new URLSearchParams(formData);
          var url = currentForm.action + '?' + params.toString();
          url = window.buildSidebarUrlWithBatteriefinder(url);
          window.applySidebarFilterAjax(url);
        });
      });

      // Dimension buttons
      currentForm.querySelectorAll('[data-ajax-dimension]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          // Form submit is already handled in the dimension logic
          // We just trigger it via AJAX instead
          var formData = new FormData(currentForm);
          var params = new URLSearchParams(formData);
          var url = currentForm.action + '?' + params.toString();
          url = window.buildSidebarUrlWithBatteriefinder(url);
          window.applySidebarFilterAjax(url);
        });
      });

      // Active filter remove buttons
      document.querySelectorAll('[data-ajax-remove-filter]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var url = window.buildSidebarUrlWithBatteriefinder(this.href);
          window.applySidebarFilterAjax(url);
        });
      });

      // Clear all button
      var clearAll = document.querySelector('[data-ajax-clear-all]');
      if (clearAll) {
        clearAll.addEventListener('click', function (e) {
          e.preventDefault();
          // Use the href but ensure filter.p.tag is preserved
          var url = window.buildSidebarUrlWithBatteriefinder(this.href);
          window.applySidebarFilterAjax(url);
        });
      }
    }

    window.attachSidebarAjaxListeners = attachSidebarListeners;
    if (sidebar.closest('search-page')) {
      sidebar.addEventListener('submit', function (event) {
        event.preventDefault();
        var currentForm = sidebar.querySelector('form');
        var params = new URLSearchParams(new FormData(currentForm));
        window.applySidebarFilterAjax(currentForm.action + '?' + params.toString());
      });
    }
    attachSidebarListeners();

    // Override the dimension form submit to use AJAX
    var dimensionFacets = document.querySelectorAll('.alpha-facet[data-dimension="1"]');
    dimensionFacets.forEach(function (facet) {
      var applyBtn = facet.querySelector('[data-apply]');
      if (applyBtn) {
        // Remove existing click listeners by cloning
        var newBtn = applyBtn.cloneNode(true);
        applyBtn.parentNode.replaceChild(newBtn, applyBtn);

        newBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var formData = new FormData(form);
          var params = new URLSearchParams(formData);
          var url = form.action + '?' + params.toString();
          if (window.buildSidebarUrlWithBatteriefinder) {
            url = window.buildSidebarUrlWithBatteriefinder(url);
          }
          window.applySidebarFilterAjax(url);
        });
      }
    });
  };

function initializeCollectionSidebar() {
  window.initializeSidebarAjax();
  window.initializeAlphaSidebar();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCollectionSidebar);
} else {
  initializeCollectionSidebar();
}
